import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Button,
  Typography,
  Hidden,
  TextField,
  Paper,
} from "@material-ui/core";
import _ from "lodash";
import { useUtils } from "../../../utils";
import { useStyles } from "./style";
import withMiddleware from "../../../middleware";
import Table from "../../../components/table";
import { UserContext } from "../../../context";
import Alert from "../../../components/alert";
import {
  getUserList,
  addUser,
  editUser,
  deleteUser,
  // changePassword,
  uploadFile,
} from "./handler";
import AddUser from "./add-user";
import EditUser from "./edit-user";
// import ChangePassword from "./change-password";
import ImportError from "./import-error";
import AddIcon from "@material-ui/icons/Add";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Stats from "../../../components/stats/stats";
import {
  getUserStats,
  getUserListV2,
  changeUserPayer,
} from "../../admin/billingHandler";

function Users(props) {
  const { isGroupAdminMode = false } = props;
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [addUserLoader, setAddUserLoader] = useState(false);
  const [editUserLoader, setEditUserLoader] = useState(false);
  const [changePasswordLoader, setChangePasswordLoader] = useState(false);
  const currentUser = useContext(UserContext);
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openEditUser, setOpenEditUser] = useState(false);
  const [openImportError, setOpenImportError] = useState(false);
  const [importErrorData, setImportErrorData] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [row, setRow] = useState({});
  // const [showAddAdmin, setShowAddAdmin] = useState(false);
  const { getEncPassword, showToast } = useUtils();
  const [stats, setStats] = useState({
    weeklyActive: 0, // weekly active users: show chart with the % of active users, % of increase or decrease from previous week,
    // and a tooltip i icon to show more details about what the stats are showing
    internal: 0,
    external: 0,
    totalUsers: 0,
  });
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const result = await getUserStats(props.service);
        console.log(result);

        setStats({
          weeklyActive: result.total_active_users ?? 0,
          internal: result.total_internal_users ?? 0,
          external: result.total_external_users ?? 0,
          totalUsers: result.total ?? 0,
          billingFrom: result.billing_from,
          billingTo: result.billing_to,
        });
      } catch (error) {
        console.error("Failed to load billing stats:", error);
      }
    };
    if (!isGroupAdminMode) {
      fetchStats();
    }
  }, [isGroupAdminMode]);

  useEffect(() => {
    getUsers();
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const tableHeader = [
    {
      title: "Name",
      field: "fullName",
      render: (rowData) => `${rowData.full_name}`,
      customSort: (a, b) => `${a.full_name}`.localeCompare(`${b.full_name}`),
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "User type",
      field: "type",
      render: (rowData) => {
        const label = rowData.display_user_type || "Internal";
        let background = "#E8F5E9";
        let color = "#388E3C";

        if (label.toLowerCase() === "admin") {
          background = "#FFEBEE";
          color = "#D32F2F";
        } else if (label.toLowerCase() === "external") {
          background = "#FFF3E0";
          color = "#F57C00";
        }

        return (
          <span
            style={{
              backgroundColor: background,
              color: color,
              padding: "4px 8px",
              borderRadius: "6px",
              fontSize: 13,
              fontWeight: 500,
              textTransform: "capitalize",
              display: "inline-block",
              minWidth: 70,
              textAlign: "center",
            }}
          >
            {label}
          </span>
        );
      },
    },
    {
      title: "Last activity",
      field: "lastLogin",
      render: (rowData) => {
        if (rowData.last_activity_date) {
          const date = rowData.last_activity_date;
          return new Date(date).toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
          });
        }
        return "N/A";
      },
    },
    {
      title: "Last activity type",
      field: "lastActivity",
      render: (rowData) => {
        if (rowData.last_activity_type) {
          const activity = rowData.last_activity_type;
          return activity.charAt(0).toUpperCase() + activity.slice(1).toLowerCase();
        }
        return "N/A";
      },
    },
    {
      title: "Signup date",
      field: "dateAdded",
      render: (rowData) => {
        const date = rowData.date_added || "2025-04-15";
        return new Date(date).toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
    },
    {
      title: "Payer",
      field: "subscription_payer",
      render: (rowData) => {
        return rowData.subscription_payer || "Org";
      },
    },
  ];

  async function getUsers() {
    try {
      setLoading(true);
      setColumns(tableHeader);
      // const userList = await getUserList(
      //   props.service,
      //   currentUser.current_org_id,
      //   currentUser.user_id
      // );
      // const users = userList.mappedUsers;
      const userList = await getUserListV2(props.service, isGroupAdminMode, currentUser.user_id, currentUser?.current_group_id);
      const users = userList.mappedUsers;
      // console.log(users);
      setData(users);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  function onActionClick(e, row, key) {
    setRow(row);
    if (key === "delete") {
      setOpenDelete(true);
    }
    // if (key === "changePassword") {
    //   setOpenChangePassword(true);
    // }
    if (key === "edit") {
      // setShowAddAdmin(() => showAdmin(row, data));
      setOpenEditUser(true);
    }
  }

  async function handleAdd(user) {
    try {
      setAddUserLoader(true);
      console.log(user);
      const password = getEncPassword(user.password);
      const username = `${user.username}`;
      const data = await addUser(props.service, user, password, username, isGroupAdminMode, currentUser?.current_group_id);
      setAddUserLoader(false);
      setOpenAddUser(false);
      await getUsers();
      showToast("success", data.message);
    } catch (error) {
      setAddUserLoader(false);
      showToast("error", error.message);
    }
  }

  async function handleEdit(user) {
    try {
      setEditUserLoader(true);
      const data = await editUser(props.service, user, row["user_id"], isGroupAdminMode);

      setEditUserLoader(false);
      setOpenEditUser(false);
      await getUsers();
      showToast("success", data.message);
    } catch (error) {
      setEditUserLoader(false);
      showToast("error", error.message);
    }
  }

  async function handleDeleteUser() {
    try {
      setLoading(true);
      setOpenDelete(false);
      const data = await deleteUser(
        props.service,
        row["user_id"],
        row["isAdmin"] === "Yes" ? "org" : "",
        row["isExternal"] === "Yes" ? "true" : "false",
        currentUser.current_org_id
      );
      showToast("success", data.message);
      await getUsers();
    } catch (error) {
      showToast("error", error.message);
    } finally {
      setLoading(false);
    }
  }

  // async function handleChangePassword(user) {
  //   try {
  //     setChangePasswordLoader(true);
  //     const passwordEnc = getEncPassword(user.password);
  //     const data = await changePassword(props.service, row["user_id"], passwordEnc, currentUser.current_org_id.toString());
  //     showToast("success", data.message);
  //     setChangePasswordLoader(false);
  //     setOpenChangePassword(false);
  //   } catch (error) {
  //     setChangePasswordLoader(false);
  //     showToast("error", error.message);
  //   }
  // }

  function validateFileType(file) {
    var filePath = file.name;
    var allowedExtensions = /(\.csv)$/i;
    if (!allowedExtensions.exec(filePath)) {
      showToast("error", "Please upload file having extension .csv only.");
      file.value = "";
      return false;
    }
    return true;
  }

  //! what dose handleUploadFile(import) function do
  async function handleUploadFile(e) {
    const file = e.target.files[0];
    try {
      setLoading(true);
      if (validateFileType(file)) {
        const data = await uploadFile(props.service, file, currentUser.current_org_id, currentUser.domainname);
        if (data.data && data.data.failed) {
          setOpenImportError(true);
          setImportErrorData(data.data.failed);
        } else {
          showToast("success", data.message || data.data.message);
        }
        await getUsers();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showToast("error", "Invalid data");
    }
  }

  const handleChangePayer = async (userId) => {
    console.log("user ID:", userId);
    try {
      const response = await changeUserPayer(props.service, userId);
      if (response.success) {
        showToast("success", "Payer changed successfully");
        return true;
      } else {
        showToast("error", response.message || "Something went wrong");
        return false;
      }
    } catch (error) {
      showToast("error", "Error changing payer");
      return false;
    }
  };

  const filteredData = data.filter((user) => {
    if (!searchTerm) return true;
    return (
      user.full_name.toLowerCase().includes(searchTerm) ||
      user.email.toLowerCase().includes(searchTerm) ||
      user.display_user_type.toLowerCase().includes(searchTerm)
    );
  });

  return (
    <div className={classes.root}>
      <Grid item xs={12} className={classes.table}>
        {isGroupAdminMode ? null : <Stats stats={stats} />}
        <Grid container spacing={2} alignItems="center" wrap="wrap" style={{ marginBottom: 16 }}>
          {isGroupAdminMode ? null : (
            <Grid item>
              <Button variant="contained" component="label" color="primary" startIcon={<CloudUploadIcon />}>
                Import
                <input type="file" hidden onChange={handleUploadFile} />
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={() => setOpenAddUser(true)}>
              Add New
            </Button>
          </Grid>

          <Grid item xs>
            <TextField fullWidth placeholder="Search users..." variant="outlined" size="small" onChange={handleSearchChange} />
          </Grid>
        </Grid>
        <Table
          onActionClick={onActionClick}
          columns={columns}
          data={filteredData}
          loading={loading}
          dynamicAction={true}
          options={{
            search: false,
            toolbar: false,
          }}
          actions={[
            { tooltip: "Edit", icon: "edit", key: "edit" },
            // {
            //   tooltip: "Change Password",
            //   icon: "vpn_key",
            //   key: "changePassword",
            // },
          ]}
        />
      </Grid>
      <AddUser
        openAddUser={openAddUser}
        closeHandler={setOpenAddUser}
        addHandler={handleAdd}
        service={props?.service}
        loader={addUserLoader}
        isGroupAdminMode={isGroupAdminMode}
      />
      <EditUser
        openEditUser={openEditUser}
        closeHandler={setOpenEditUser}
        addHandler={handleEdit}
        changePayerHandler={handleChangePayer}
        loader={editUserLoader}
        row={row}
        isGroupAdminMode={isGroupAdminMode}
        currentUser={currentUser}
        service={props?.service}
      />
      <Alert
        title="Remove user from organization?"
        content="Are you sure you want to remove user from organization?"
        open={openDelete}
        onConfirm={handleDeleteUser}
        onClose={() => setOpenDelete(false)}
      />
      {/* <ChangePassword
        openChangePassword={openChangePassword}
        closeHandler={setOpenChangePassword}
        changePasswordHandler={handleChangePassword}
        loader={changePasswordLoader}
      /> */}
      {openImportError && <ImportError openImportError={openImportError} closeHandler={setOpenImportError} data={importErrorData} />}
    </div>
  );
}

export default withMiddleware(Users);
